<template>
  <div class="payBill">
    <el-collapse v-model="activeNames" class="collapse-main-content">
      <el-collapse-item name="1">
        <template slot="title">
          <div class="collapse-title-pre"> <span></span>基本信息 </div>
        </template>
        <div class="collapse-content">
          <BasicInfo
            :canEdit="basicInfoCanEdit"
            :type="'pay'"
            :companyList="companyList"
            @getDepartment="getDepartment"
            @expiringDateChange="expiringDateChange"
            @billMakeBankAccountChange="billMakeBankAccountChange"
            @marginBankAccountChange="marginBankAccountChange"
            ref="basicInfo"
          />
        </div>
      </el-collapse-item>
      <el-collapse-item name="2">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>{{ this.$t('billDetail.collapseTitle.billPaymentTitle') }}
          </div>
        </template>
        <div class="collapse-content">
          <el-tabs type="border-card" v-model="activeNameTab" class="addCooperationTabs">
            <!--贴现信息-->
            <el-tab-pane :label="$t('billDetail.tabTitle.discountTitle')" name="discount">
              <discount-info
                ref="discount"
                :canEdit="canEdit"
                :isEdit="isEdit"
                :basicInfo="baseInfo"
                :departmentList="departmentList"
              ></discount-info>
              <!-- :fundPaymentBillFlag="fundPaymentBillFlag" -->
            </el-tab-pane>
            <!--解付信息-->
            <el-tab-pane :label="$t('billDetail.tabTitle.paymentTitle')" name="first">
              <payment-info
                :canEdit="paymentCanEdit"
                :isEdit="isEdit"
                ref="payment"
                @getData="getData"
                @marginBankAccountChange="marginBankAccountChange"
              ></payment-info>
            </el-tab-pane>
            <!--会计凭证-->
            <el-tab-pane
              :label="$t('billDetail.tabTitle.accountingVoucherTitle')"
              name="voucherTab"
            >
              <voucher
                ref="voucher"
                :voucherList="voucherList"
                @reverseInfo="reverseInfo"
                @postInfo="postInfo"
              ></voucher>
            </el-tab-pane>
          </el-tabs>
        </div>
      </el-collapse-item>
      <!--付款信息-->
      <el-collapse-item name="3" v-if="showPayInfo">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>{{ this.$t('billDetail.collapseTitle.payInfoTitle') }}
          </div>
        </template>
        <div class="collapse-content">
          <pay-info-table ref="payInfoRef"></pay-info-table>
        </div>
      </el-collapse-item>
      <!--上传附件-->
      <el-collapse-item name="4">
        <template slot="title">
          <div class="collapse-title-pre">
            <span></span>{{ this.$t('billDetail.collapseTitle.payBillTitle') }}
          </div>
        </template>
        <div class="collapse-content">
          <!-- <upload :isShow="canEdit" @upload="handleUpload" :tableData="fundAttachmentList || []" /> -->
          <FileTable
            ref="fileTableRef"
            :attachments="fundAttachmentList || []"
            :isShowDownBtn="!canEdit"
          />
        </div>
      </el-collapse-item>
    </el-collapse>
    <div class="fixed-bottom-btnList">
      <el-button
        v-if="this.$route.name.indexOf('Details') != -1"
        type="primary"
        @click="canEdit = !canEdit"
        :disabled="billStatus != '01'"
        class="fixed-bottom-btn"
        v-hasPermi="['2021050810262237172']"
        >{{ this.$t('functionBtn.editToggle') }}</el-button
      >
      <el-button
        type="primary"
        :disabled="billStatus == '03' || !canEdit"
        @click="save('SAVE_FUNDBILL')"
        class="fixed-bottom-btn"
        v-hasPermi="['2021050810264380899']"
        >{{ this.$t('billDetail.button.save') }}</el-button
      >
      <!-- 已解付 -->
      <el-button
        :disabled="!canEdit || !billStatus"
        type="primary"
        @click="save('SAVE_PAYMENT_FUNDBILL')"
        class="fixed-bottom-btn"
        v-hasPermi="['2021050810273803357']"
        >{{ this.$t('billDetail.button.payment') }}</el-button
      >
      <!--  <el-button
        :disabled="
          !billStatus ||
          ['notgenerate', 'generated', 'postError'].indexOf(baseInfo.accountingStatus) == -1
        "
        type="primary"
        @click="handleAccountEntry"
        class="fixed-bottom-btn"
        v-hasPermi="['2021050810281658869']"
        >生成保证金凭证</el-button
      >
      <el-button
        :disabled="['generated', 'postError'].indexOf(baseInfo.accountingStatus) == -1"
        type="primary"
        @click="doSyncVoucherForEntityData()"
        class="fixed-bottom-btn"
        v-hasPermi="['2021050810284195187']"
        >过账保证金凭证</el-button
      >
      <el-button
        :disabled="['posted'].indexOf(baseInfo.accountingStatus) == -1"
        type="primary"
        @click="doReverseAccountEntry"
        class="fixed-bottom-btn"
        v-hasPermi="['2021050810295454077']"
        >冲销保证金凭证</el-button
      > -->
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex';
  import discountInfo from '../components/discountInfo';
  import BasicInfo from '../components/basicInfo';
  import paymentInfo from '../components/paymentInfo';
  // import accountingVoucher from '../components/accountingVoucher';
  import API from '@/api/capitalCenter/bill';
  import voucherMixins from '@/common/mixins/voucher.js';
  import DataBaseAPI from '@/api/dataBase';
  // import { includes } from 'xe-utils/methods';
  import payInfoTable from '../components/payInfoTable';

  export default {
    name: 'payBill',
    mixins: [voucherMixins],
    components: {
      BasicInfo,
      paymentInfo,
      payInfoTable,
      discountInfo,
      // accountingVoucher,
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      basicInfoCanEdit() {
        let flag = false;
        flag = this.canEdit && ['', null, '01'].includes(this.billStatus);
        console.log(flag);
        return flag;
      },
      paymentCanEdit() {
        let flag = false;
        flag = this.canEdit && ['', null, '01'].includes(this.billStatus);
        return flag;
      },
      showPayInfo() {
        if (this.$route.name.indexOf('Details') != -1) {
          return true;
        }
        return false;
      },
    },
    data() {
      return {
        canEdit: true,
        activeNames: ['1', '2', '3', '4'],
        baseInfo: {
          companyCode: null,
          departmentCode: null,
        },
        paymentInfo: {},
        billStatus: null,
        isEdit: true,
        companyList: [],
        fundAttachmentList: [],
        departmentList: [],
        fundPaymentBillFlag: null, //是否被付款单引用，为“1”时代表已被付款单引用
        voucherFlag: 'AE_AP_MARGIN_BILL', //凭证标识
      };
    },
    mounted() {
      this.getCompany();
      if (this.$route.query.id) {
        this.getData();
      }
      if (this.$route.name.indexOf('Details') != -1) {
        this.canEdit = false;
      }
      if (this.$route.query.paymentApplyId) {
        this.getFundBillByPaymentApply();
      }
    },
    methods: {
      // 部门（本人权限）
      getDepartment(val) {
        this.departmentList = val;
      },
      importDetail(allDetail) {
        console.log('getDetail', allDetail);
        // 基本信息
        let basicInfo = this.$refs.basicInfo.baseData;
        Object.keys(basicInfo).map((item) => {
          if (item.indexOf('is') == 0) {
            return (basicInfo[item] = allDetail[item] == '1' ? true : false);
          } else {
            return (basicInfo[item] = allDetail[item]);
          }
        });
        this.fundPaymentBillFlag = allDetail.fundPaymentBillFlag;
        this.baseInfo = basicInfo;
        this.paymentInfo = allDetail.fundBillPayment;
        this.billStatus = allDetail.billStatus;
        this.$refs.basicInfo.getDepartment(basicInfo.billCompanyCode);
        this.$refs.basicInfo.getBankInfo(basicInfo.billTakerNo, basicInfo.billCompanyCode);
        // 解付
        this.getFormData('payment', allDetail.fundBillPayment);
        this.getFormData('discount', allDetail.fundBillDiscount);
        // 附件
        this.fundAttachmentList = allDetail.returnAttachmentList;
        // 获取凭证ID 获取凭证列表
        this.entityDataId = allDetail.id;
        this.getAccountEntry();
        this.$refs.payment.entityDataId = allDetail.id;
        this.$refs.payment.getAccountEntry();
        this.$refs.payInfoRef.getData(allDetail.billCode);
      },
      // 获取详情数据
      async getData() {
        this.loading.startLoading();
        let res = await this.$axios.get(API.QUERY_FUNDBILL_BY_ID, {
          id: this.$route.query.id || this.baseInfo.id,
        });
        if (res) {
          this.loading.endLoading();
          if (res.data.code == 0) {
            this.importDetail(res.data.data);
          }
        }
      },
      // 获取详情数据
      async getFundBillByPaymentApply() {
        this.loading.startLoading();
        let res = await this.$axios.get(API.QUERY_FUNDBILL_BY_PAYMENTAPPLYID, {
          id: this.$route.query.paymentApplyId,
        });
        if (res) {
          this.loading.endLoading();
          if (res.data.code == 0) {
            this.importDetail(res.data.data);
          }
        }
      },
      getFormData(name, returnData) {
        let data = this.$refs[name].baseData;
        if (returnData) {
          Object.keys(data).map((item) => {
            return (data[item] = returnData[item]);
          });
        }
      },
      async getCompany() {
        // 公司
        let params = {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
        };
        const selectStatus = await this.$axios.post(DataBaseAPI.GET_PERSON_API, params);
        if (selectStatus.data.code == 0) {
          this.companyList = selectStatus.data.data.personCompanyInfo.map((item) => {
            return {
              value: item.personCompanyCode,
              label: item.personCompanyName,
            };
          });
        }
      },
      // 保存
      async save(apiName) {
        if (apiName == 'SAVE_PAYMENT_FUNDBILL') {
          this.marginBankAccountChange('marginAmount');
        }
        // 基本信息
        let basicInfo = await this.$refs.basicInfo.exportChildData();
        // 解付
        let fundBillPayment = await this.$refs.payment.exportChildData();

        let fundBillDiscount = this.$refs.discount.exportChildData(); // 贴现

        if (basicInfo && fundBillPayment) {
          if (!basicInfo.cashflowCode && basicInfo.marginAmount && basicInfo.marginAmount !== 0) {
            basicInfo.cashflowCode = '999999';
            this.$refs.basicInfo.baseData.cashflowCode = '999999';
          }
          let params = {
            billType: '2',
            ...basicInfo,
            fundBillPayment,
            fundAttachmentList: this.$refs.fileTableRef?.getTableData(),
            fundBillDiscount: fundBillDiscount,
          };
          params = this.$baseRequest.assignObj(params);
          this.loading.startLoading();
          let res = await this.$axios.post(API[apiName], params);
          if (res) {
            this.loading.endLoading();
            if (res.data.code == 0) {
              this.$message({
                showClose: true,
                type: 'success',
                message: res.data.msg,
              });
              this.returnPath();
              //this.importDetail(res.data.data);
              if (apiName == 'SAVE_PAYMENT_FUNDBILL') {
                this.canEdit = false;
              }
            } else {
              this.$message({
                showClose: true,
                type: 'error',
                message: res.data.msg,
              });
            }
          }
        }
      },
      returnPath() {
        // 返回列表页
        let path = {
          fromPath: {
            path: this.$route.path,
            name: this.$route.name,
            meta: { keepAlive: true },
          },
          toPath: {
            path: '/capital/payBillManage',
            name: 'payBillManage',
            meta: { keepAlive: false },
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
      expiringDateChange(val) {
        // 解付日期默认到期日，可修改
        this.$refs.payment.baseData.payDate = val;
      },
      billMakeBankAccountChange(val) {
        // 解付银行账号默认出票银行账号，可修改
        if (val && val.length > 0) {
          this.$refs.payment.baseData.bankAccount = val[0].bankAccountNum;
          this.$refs.payment.baseData.bankUnionNumber = val[0].branchCode;
        } else {
          this.$refs.payment.baseData.bankAccount = null;
          this.$refs.payment.baseData.bankUnionNumber = null;
        }
      },
      marginBankAccountChange(prop) {
        // 保证金支付银行
        let marginBankAccount = this.$refs.basicInfo.baseData.marginBankAccount; // 保证金银行
        let marginPayAmount = this.$refs.payment.baseData.marginPayAmount; // 保证金解付金额
        let marginAmount = this.$cal.calCommon(
          this.$refs.basicInfo.baseData.billAmount,
          this.$refs.basicInfo.baseData.marginRate,
          '*',
          'amount'
        ); // 保证金金额
        if (prop == 'marginAmount') {
          this.$refs.payment.baseData.marginPayAmount = marginAmount; //保证金解付金额默认=保证金金额，可修改
          this.$refs.payment.baseData.payAmount = this.$cal.calCommon(
            this.$refs.basicInfo.baseData.billAmount,
            marginAmount,
            '-',
            'amount'
          ); //存款解付金额默认=票据金额-保证金解付金额，可修改
          marginPayAmount = this.$refs.payment.baseData.marginPayAmount; // 保证金解付金额
        }
        if (marginPayAmount && marginPayAmount != 0) {
          this.$refs.payment.baseData.marginBankAccount = marginBankAccount;
        } else {
          this.$refs.payment.baseData.marginBankAccount = null;
        }
      },
      // // 附件上传
      // handleUpload(uploadTableData) {
      //   this.fundAttachmentList = uploadTableData;
      // },
    },
  };
</script>
